import { render, staticRenderFns } from "./modsApp.vue?vue&type=template&id=e64ae44e&scoped=true"
import script from "./modsApp.vue?vue&type=script&lang=js"
export * from "./modsApp.vue?vue&type=script&lang=js"
import style0 from "./modsApp.vue?vue&type=style&index=0&id=e64ae44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64ae44e",
  null
  
)

export default component.exports